/* Dermatinta: progressive scroll enhancement; the shared policy owns preferences. */
(function () {
  'use strict';
  if (window.DTStoryMotion) return;
  var root = document.documentElement;
  var policy = window.DTMotion;
  var capable = !!(window.IntersectionObserver && window.requestAnimationFrame && policy && typeof policy.quiet === 'function');
  var selector = '#contenido section, .ingr__esfera, .lp-foto, .item, .pdp__bloque, .ingr__ph, [data-dt-reveal], [data-dt-parallax]';
  var protectedSelector = '.hero, .lp-hero, #inicio, [fetchpriority="high"], [data-dt-lcp], [data-dt-motion="off"]';
  var records = new Map();
  var paths = document.querySelectorAll('[data-dt-marco] path');
  var pending = 0;
  var printing = false;
  var destroyed = false;
  var listeners = [];
  var unsubscribe = null;
  function quiet() { return destroyed || printing || document.hidden || !capable || policy.quiet(); }
  function clamp(value, low, high) { return Math.min(high, Math.max(low, value)); }
  function draw(progress) {
    paths.forEach(function (path) {
      var leaf = path.classList.contains('rama__hoja');
      var index = Number(path.style.getPropertyValue('--i')) || 0;
      var value = leaf ? clamp((progress - (0.10 + index * 0.08)) / 0.18, 0, 1) : progress;
      path.style.setProperty('stroke-dashoffset', String(1 - value));
    });
  }
  function update() {
    pending = 0;
    if (quiet() || document.hidden) return;
    var height = window.innerHeight || root.clientHeight;
    var extent = Math.max(root.scrollHeight, document.body.scrollHeight) - height;
    var movements = [];
    records.forEach(function (record, el) {
      if (!record.parallax || !record.active) return;
      var rect = el.getBoundingClientRect();
      var requested = Number(el.getAttribute('data-dt-parallax'));
      var limit = window.innerWidth < 750 ? 8 : 16;
      if (el.getAttribute('data-dt-parallax') !== null && el.getAttribute('data-dt-parallax') !== '' && Number.isFinite(requested)) limit = clamp(Math.abs(requested), 0, limit);
      movements.push([el, clamp((height / 2 - rect.top - rect.height / 2) / height * limit * 2, -limit, limit)]);
    });
    draw(extent > 0 ? clamp(window.scrollY / extent, 0, 1) : 1);
    movements.forEach(function (move) { move[0].style.setProperty('--dt-parallax-y', move[1].toFixed(2) + 'px'); });
  }
  function schedule() {
    if (!pending && !quiet() && !document.hidden) pending = window.requestAnimationFrame(update);
  }
  var observer = capable ? new window.IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var record = records.get(entry.target);
      if (!record) return;
      record.active = entry.isIntersecting;
      if (entry.isIntersecting) entry.target.classList.add('dt-in');
      entry.target.classList.toggle('dt-onstage', entry.isIntersecting && !quiet());
      if (!entry.isIntersecting && record.parallax) entry.target.style.setProperty('--dt-parallax-y', '0px');
    });
    schedule();
  }, { threshold: 0.01 }) : null;
  function refresh() {
    if (destroyed) return;
    var stopped = quiet();
    root.classList.toggle('dt-motion-quiet', stopped);
    root.classList.toggle('dt-motion-ready', !stopped);
    if (stopped) {
      if (pending) window.cancelAnimationFrame(pending);
      pending = 0;
      records.forEach(function (_, el) {
        el.classList.add('dt-in');
        el.classList.remove('dt-onstage');
        el.style.setProperty('--dt-parallax-y', '0px');
      });
      draw(1);
    } else {
      records.forEach(function (record, el) { el.classList.toggle('dt-onstage', record.active); });
      schedule();
    }
  }
  function add(el) {
    if (records.has(el) || el.closest(protectedSelector) || el.querySelector('[fetchpriority="high"], [data-dt-lcp]')) return;
    el.classList.add('dt-reveal');
    if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('dt-in');
    var sphere = el.classList.contains('ingr__esfera');
    var parallax = el.matches('.lp-foto, [data-dt-parallax]');
    if (sphere) {
      var siblings = el.parentElement ? Array.from(el.parentElement.querySelectorAll('.ingr__esfera')) : [el];
      el.style.setProperty('--dt-stagger', Math.min(Math.max(0, siblings.indexOf(el)), 6) * 90 + 'ms');
    }
    if (parallax) el.classList.add('dt-parallax');
    records.set(el, { active: false, parallax: parallax });
    if (observer) observer.observe(el);
  }
  function scan(scope) {
    if (destroyed) return;
    if (scope.matches && scope.matches(selector)) add(scope);
    scope.querySelectorAll(selector).forEach(add);
    paths = document.querySelectorAll('[data-dt-marco] path');
    refresh();
  }
  function release(el) {
    if (observer) observer.unobserve(el);
    el.classList.remove('dt-reveal', 'dt-in', 'dt-onstage', 'dt-parallax');
    el.style.removeProperty('--dt-parallax-y');
    el.style.removeProperty('--dt-stagger');
    records.delete(el);
  }
  function listen(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listeners.push(function () { target.removeEventListener(type, handler, options); });
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    if (pending) window.cancelAnimationFrame(pending);
    pending = 0;
    if (observer) observer.disconnect();
    records.forEach(function (_, el) { release(el); });
    draw(1);
    listeners.forEach(function (off) { off(); });
    if (typeof unsubscribe === 'function') unsubscribe();
    root.classList.remove('dt-motion-ready', 'dt-motion-quiet');
    delete window.DTStoryMotion;
  }
  window.DTStoryMotion = { refresh: function () { scan(document); }, destroy: destroy };
  listen(window, 'scroll', schedule, { passive: true });
  listen(window, 'resize', schedule, { passive: true });
  listen(document, 'visibilitychange', refresh);
  listen(window, 'beforeprint', function () { printing = true; refresh(); });
  listen(window, 'afterprint', function () { printing = false; refresh(); });
  listen(document, 'shopify:section:load', function (event) { scan(event.target); });
  listen(document, 'shopify:section:unload', function (event) {
    records.forEach(function (_, el) { if (event.target.contains(el)) release(el); });
    schedule();
  });
  if (policy && typeof policy.subscribe === 'function') unsubscribe = policy.subscribe(refresh);
  if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
}());
